/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const LocationMetas = {
  DestinationName: "DestinationName",
  DestinationId: "DestinationId",
  PatientIdType: "PatientIdType",
};

export const EmrIntegrations = [
  { id: "adt", name: "ADT" },
  { id: "bth", name: "BTH" },
  { id: "dft", name: "DFT" },
  { id: "orm", name: "ORM" },
  { id: "oru", name: "ORU" },
  { id: "rls", name: "RLS" },
  { id: "siu", name: "SIU" },
  { id: "fhir", name: "FHIR PATIENT QUERY" },
];
